import { render, staticRenderFns } from "./UserNameInput.vue?vue&type=template&id=31401e42&"
import script from "./UserNameInput.vue?vue&type=script&lang=ts&"
export * from "./UserNameInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports